import { render } from "./SvgLights.vue?vue&type=template&id=91e357f6&ts=true"
import script from "./SvgLights.vue?vue&type=script&lang=ts"
export * from "./SvgLights.vue?vue&type=script&lang=ts"

import "./SvgLights.vue?vue&type=style&index=0&id=91e357f6&lang=css"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__